import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import io from 'socket.io-client';
// import loadable from '@loadable/component';
// import { Chart as ChartJS } from 'chart.js/auto';
import { getCurrentcolor } from '../redux/reducers/color.reducer';
import { getCurrentBranding } from '../redux/reducers/branding.reducer';
import { conversationsActions } from '../redux/actions/conversations.action';
import { setGlobalColors, changeFaviconAndDocumentTitle, isWebView, isIOS, isIosApp } from '../Utilities';
import { Loader } from '../Components/Common/Loader/Loading';
import './App.scss';
import { history, Routes } from '../Routing';
import { dashboardActions } from '../redux/actions/dashboard.action';
import { getCurrentLoadingStatus, getStatusOfSpinner } from '../redux/reducers/loading.reducer';
import withClearCache from './BustCache';
import { get, server } from '../Utilities/Remote';
import DevToolsBlocker from './Debugger';
import { getClientId, getClientUserId, getRoleArray } from '../redux/reducers/clientUserId.reducer';
import { ToastContainer } from 'react-toastify';
import { getCreditsAvailable } from '../redux/reducers/dashboard.reducer';
import { getToken } from '../redux/reducers/userProfile.reducer';
import { CreditsModalProvider } from '../Components/Common/ToastModal/ToastModal';
import { disconnectSocket, initSocket } from './socket';
import { initRouteTracking } from '../Utilities/analytics';

function MainApp(props) {
  const {
    color,
    currentbranding,
    isLoading,
    clientId,
    clientUserId,
    isSpinner,

    token,
    setCreditsAvailableToStore,
  } = props;

  /**
   * Retrieves or generates a unique ID for the browser and gathers system info.
   * @returns {string} JSON string of the device data.
   */

  useEffect(() => {
    if (!clientUserId) return;

    const socket = initSocket();

    socket.on('connect', () => {
      console.log(socket.id, 'connected');
      socket.emit('user-connected', { client_user_id: clientUserId });
    });

    socket.on('reconnect', () => {
      socket.emit('user-connected', { client_user_id: clientUserId });
    });

    socket.on('disconnect', () => {
      socket.connect();
    });

    return () => disconnectSocket();
  }, [clientUserId]);

  // SPA page_view events for any injected analytics tags (no-op until one loads)
  useEffect(() => {
    initRouteTracking();
  }, []);

  useEffect(() => {
    if (Object.keys(color.color) !== 0) {
      const {
        primary,
        light,
        lightest,
        superlight,
        materialLight,
        materialDark,
        materialContrastText,
      } = color.color;
      setGlobalColors(primary, light, lightest, superlight, {
        light: materialLight,
        dark: materialDark,
        contrastText: materialContrastText,
      });
    }

    if (Object.keys(currentbranding.branding) !== 0) {
      const { client_icon: clientIcon, client_title: clientTitle } = currentbranding.branding;
      changeFaviconAndDocumentTitle(clientIcon, clientTitle);
    }
  }, [color, currentbranding, isSpinner]);

  useEffect(() => {
    get({ client_id: clientId }, '/getCreditsOfClient').then((res) => {
      if (res && res.success) {
        const credits = Number(res.result).toFixed(2);
        if (token) {
          if (credits < 1 && process.env.NODE_ENV === 'production') {
            history.replace('/service-unavailable');
            document.body.style.overflow = 'hidden';
          }
        }
        setCreditsAvailableToStore(credits);
      }
    });
  }, [token]);

  useEffect(() => {
  if (!isIosApp) {
    return;
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const scrollPositions = {};

  const handleScroll = () => {
    scrollPositions[window.location.pathname] = window.scrollY;
  };

  const handlePopState = () => {
    const savedY = scrollPositions[window.location.pathname] || 0;

    requestAnimationFrame(() => {
      document.body.style.transform = 'translateZ(0)';
      void document.body.offsetHeight;

      window.scrollTo(0, savedY);

      requestAnimationFrame(() => {
        document.body.style.transform = '';
        window.scrollBy(0, 1);
        window.scrollBy(0, -1);
      });
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('popstate', handlePopState);

  return () => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('popstate', handlePopState);
  };
}, []);

  return (
    <Container fluid className='p-0 m-0 rootContainer mx-auto'>
      <DevToolsBlocker>
        <CreditsModalProvider>
          {isLoading && <Loader isSpinner={isSpinner} />}
          <ConnectedRouter history={history}>
            <Routes />
            <ToastContainer />
          </ConnectedRouter>
        </CreditsModalProvider>
      </DevToolsBlocker>
    </Container>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSocket: (socket) => {
      dispatch(conversationsActions.setSocket(socket));
    },
    setScrolledHeightOfDocumentToStore: (payload) => {
      dispatch(dashboardActions.setScrolledHeightOfDocumentToStore(payload));
    },
    setCreditsAvailableToStore: (payload) => {
      dispatch(dashboardActions.setCreditsAvailableToStore(payload));
    },
  };
};

const mapStateToProps = (state) => ({
  color: getCurrentcolor(state),
  currentbranding: getCurrentBranding(state),
  creditsAvailable: getCreditsAvailable(state),
  isLoading: getCurrentLoadingStatus(state),
  isSpinner: getStatusOfSpinner(state),
  clientId: getClientId(state),
  clientUserId: getClientUserId(state),
  roleArray: getRoleArray(state),
  token: getToken(state),
});

const BustCache = withClearCache(connect(mapStateToProps, mapDispatchToProps)(MainApp));

function App() {
  return <BustCache />;
}

export default App;

MainApp.propTypes = {
  color: PropTypes.shape({
    color: PropTypes.shape({
      primary: PropTypes.string,
      light: PropTypes.string,
      lighter: PropTypes.string,
      superLight: PropTypes.string,
    }),
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  currentbranding: PropTypes.shape({
    branding: PropTypes.instanceOf(Object).isRequired,
  }).isRequired,
  isSpinner: PropTypes.bool.isRequired,
  setSocket: PropTypes.func.isRequired,
  setScrolledHeightOfDocumentToStore: PropTypes.func.isRequired,
};
